import { getBasket, type BasketItem } from 'api/v2/expenses/basket';
import useBasketDraftList from 'hooks/useBasketDraftList';
import useQuery from 'hooks/react-query/useQuery';
import { type UseQueryResult } from '@tanstack/react-query';
import { ExpensesCacheKeys } from 'types/cacheKeys.types';
import type { Paging } from 'types/pagination.types';

const useGetBasket = (): UseQueryResult<{
  items: BasketItem[];
  paging: Paging;
}> => {
  const basketDraftAPI = useBasketDraftList();

  return useQuery(ExpensesCacheKeys.BasketItems, getBasket, {
    select: (data) => ({
      ...data,
      items: basketDraftAPI.basketDraftList.concat(data.items),
    }),
  });
};

export default useGetBasket;
